import { useLocalesQuery } from '@/api/queries/locales/useLocalesQuery';
import type { Translate } from '@/plugins/i18n/types';
import { computed, inject } from 'vue';

export function useLanguageList() {
  const t = inject('t') as Translate;

  const { availableLocales: locales } = useLocalesQuery();

  function getLanguageKey(isoCode: string, localized = false) {
    //@todo: remove condition when chinese issue fixed
    const formattedIsoCode = isoCode.includes('zh')
      ? 'zh_cn'
      : isoCode.toLowerCase().replace('-', '_');

    return `language${localized ? '.localized' : ''}.${formattedIsoCode}`;
  }

  // Each language name is translated into its own language.
  const languagesList = computed(() => {
    const list = locales.value?.map(locale => {
      return {
        ...locale,
        title: t(getLanguageKey(locale.iso_code_639, false)),
      };
    });

    return list?.sort((a, b) => {
      if (a.title < b.title) return -1;
      return 1;
    });
  });

  // Each language name is translated into the auth's language.
  const localizedLanguagesList = computed(() => {
    const list = locales.value?.map(locale => {
      return {
        ...locale,
        title: t(getLanguageKey(locale.iso_code_639, true)),
      };
    });

    return list?.sort((a, b) => {
      if (a.title < b.title) return -1;
      return 1;
    });
  });

  return { languagesList, localizedLanguagesList, getLanguageKey };
}
